import { Context } from '@sentry/angular';
import { getSessionParamsFromUrl } from './get-session-params.utils';

interface ClientContext extends Context {
  userAgent: string;
  browserLanguage: string;
  platform: string;
  referrer: string;
  instance: string;
  sessionId: string;
  gameUuid: string;
  isFromHub: boolean;
  hubGameUuid: string;
  gameLanguage: string;
}

export function getClientContext(): ClientContext {
  const {
    instance,
    sessionId,
    gameUuid,
    isFromHub,
    hubGameUuid,
    navigateToPlay,
    language,
  } = getSessionParamsFromUrl();

  return {
    userAgent: navigator.userAgent,
    browserLanguage: navigator.language,
    platform: navigator.platform,
    referrer: document.referrer,
    instance,
    sessionId,
    gameUuid,
    isFromHub,
    hubGameUuid,
    navigateToPlay,
    gameLanguage: language,
  };
}
